import React,{useState} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { Outlet, Link } from 'react-router-dom'
import TabNavItem from '../../common/TabNavItem'
import TabContent from '../../common/TabContent'
import PatientOverview from './PatientOverview'
import PatientAppointments from './PatientAppointments'
import PatientActivity from './PatientActivity'
import PatientCommPref from './PatientCommPref'
import PatientInvalidInfo from './PatientInvalidInfo'
import PatientEditInfo from './PatientEditInfo'
function Patient() {
    const [activeTab, setActiveTab] = useState('overview');
  return (
    <>
        <SubHeader title="Patient" description="Patient Information" />

        
       <div className="card ms-7 me-7">
          
           <div className="card-body pt-9 pb-0">
               
                    <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center mb-7">
                                <div className="symbol symbol-65px me-5">
                                    <div className="symbol-label fs-1 fw-bold text-success">JD</div>
                                </div>
                                <div className="d-flex justify-content-start flex-column">
                                    <div className="text-gray-800 text-hover-primary fs-2 fw-bolder mb-1">
                                        John Doe  <span className="text-muted fs-5 fw-bold"> (Preferred Name)</span>
                                            <span className="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2">Active</span>
                                    </div>
                                   

                                    <span className="text-muted fs-5 fw-bold mb-2"> 2nd January 1990 (33)</span>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="text-gray-600 text-hover-success fw-bold me-3"> <i className="bi bi-envelope"></i> abc@email.com</span>
                                        <span className="text-gray-600 text-hover-success fw-bold me-3"> <i className="bi bi-phone"></i> 123-123-1234</span>
                                        <span className="text-gray-600 text-hover-success fw-bold me-3"> <i className="bi bi-house"></i> 123-123-1234</span>
                                        
                                    </div>
                                    
                                </div>
                            </div>
                            {/* Address on the right*/}
                            <div className="d-flex flex-column">
                                <span className="text-gray-400 fw-bold">Address</span>
                                <span className="text-gray-600 fw-bolder">27 Beaconsfield Cres NW</span>
                                <span className="text-gray-600 fw-bolder">Calgary, AB</span>
                                <span className="text-gray-600 fw-bolder">T2J 2J8</span>
                            </div>
                    </div>
                    <div className="separator my-5"></div>
                    <div className="row">
                        <div className="col-3">
                           
                        </div>
                        <div className="col-9 col-offset-3">
                        <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                        <TabNavItem
                            title="Overview"
                            id="overview"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                          <TabNavItem
                            title="Edit Info"
                            id="editinfo"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                          <TabNavItem
                            title="Appointment"
                            id="appointment"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                          <TabNavItem
                            title="Communication Preferences"
                            id="commpref"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                          <TabNavItem
                            title="Activity"
                            id="activity"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                          <TabNavItem
                            title="Invalid Info"
                            id="invalidinfo"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                     
                    </ul>
                        </div>
                    </div>
                  


                   
              
           </div>
       </div>

       <div className="card ms-7 me-7 mt-7">
        <div className="card-body">
            <div className="row">
                <div className="col-3">
                    <div className="d-flex flex-column">
                        <button className="btn btn-light-primary mb-2">Send Email</button>
                        <button className="btn btn-light-success mb-2">Send Sms</button>
                        <button className="btn btn-light-info mb-2">Send Survey</button>
                        <button className="btn btn-light-primary mb-2">Send Article</button>
                        <button className="btn btn-light-warning mb-2">Glass Pickup Reminder</button>
                        <button className="btn btn-light-success mb-2">Contact Lens Pickup</button>
                    </div>
                    
                </div>
                <div className="col-9">
                   <TabContent id="overview" activeTab={activeTab}>
                        <PatientOverview/>
                   </TabContent>
                   <TabContent id="editinfo" activeTab={activeTab}>
                       <PatientEditInfo/>
                   </TabContent>
                   <TabContent id="appointment" activeTab={activeTab}>
                     <PatientAppointments/>
                   </TabContent>
                   <TabContent id="commpref" activeTab={activeTab}>
                        <PatientCommPref/>
                   </TabContent>
                   <TabContent id="activity" activeTab={activeTab}>
                       <PatientActivity/>
                   </TabContent>
                   <TabContent id="invalidinfo" activeTab={activeTab}>
                        <PatientInvalidInfo/>
                   </TabContent>
                </div>
            </div>
        </div>
       </div>
    </>
  )
}

export default Patient